import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class FlightsBookingServicesComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    flightBookingDetails: api.FlightBookingDetails;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    get stepTwoBrands() {
        return this.reservation.brandedProductKits?.filter(b => {
            return b.stepOnForm === 2 && b.kitTarget !== 'AdditionalPopup';
        }) ?? [];
    }

    get productsOfTypeInsuranceForServicesStep() {
        return this.reservation.productsOfTypeInsurance.filter(({ product }) =>
            product.stepNumber === 2
        );
    }

    get productOfTypeServiceOrPackageForServicesStep() {
        return this.reservation.productsOfTypeServiceOrPackage.filter(({ product }) =>
            product.stepNumber === 2 && product.flightId == this.reservation.selectedFlightIdForProducts || product.stepNumber === 2 && product.flightId == null
        );
    }

    mounted() {
        const productsRocket = [
            ...this.productsOfTypeInsuranceForServicesStep.map((product) => product.product),
            ...this.productOfTypeServiceOrPackageForServicesStep.map((product) => product.product)
        ];

        for (const brand of this.stepTwoBrands) {
            for (const product of brand.products) {
                const productByBrand = this.reservation.products.find(p => product.id && p.product.id === product.id);
                if (productByBrand) {
                    productsRocket.push(productByBrand.product);
                }
            }
        }

        new api.RetailRocket().orderFormStepOpened({
            flightKey: api.RetailRocketCL.flightKey,
            stepNumber: 2,
            products: productsRocket,
            bookingSessionId: this.flightBookingDetails.bookingSessionId,
            email: this.reservation.contacts.email
        });
    }

    onProductDetails(product: flights.ProductModel) {
        this.$emit('product-details', product);
    }

    onFlightTerms() {
        if (this.reservation.selectedFlight) {
            this.$emit('flight-terms', this.reservation.selectedFlight.uniqueId);
        }
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        this.$emit('product-selection-change', product, value);
    }

    onServiceBrandChange(product: api.Product, prevProduct: api.Product) {
        this.$emit('service-brand-change', product, prevProduct);
    }

    onSubmit() {
        if (this.productOfTypeServiceOrPackageForServicesStep.some(p => p.needToSelect) || this.stepTwoBrands.some(b => b.needToSelect)) {
            this.reservation.needToSelectToGoToNextStep = true;
            (<any>this.$root).$refs.dialogMessage.show({
                text: i18next.t('label_error_need_select_modal'),
                btnOkLabel: 'OK',
                persistent: true,
                btnOkColorClass: 'btn-alternate',
                btnOkHandler() {
                    (<any>this).$refs.dialog.isActive = false;
                }
            });
            return;
        } else {
            this.reservation.needToSelectToGoToNextStep = false;
        }

        this.$emit('submit');
    }
}
